<script>
import Vue from 'vue';
import {mapState, mapGetters, mapActions} from 'vuex';
import PaginationControl from '../PaginationControl/PaginationControl.vue';
import DashboardNotificationsItem from '../DashboardNotificationsItem/DashboardNotificationsItem.vue';
import DashboardNotificationsFilters from '../DashboardNotificationsFilters/DashboardNotificationsFilters.vue';
import Fake from '../Fake/Fake.vue';

export default Vue.extend({
    components: {
        Fake,
        PaginationControl,
        DashboardNotificationsItem,
        DashboardNotificationsFilters
    },
    computed: {
        ...mapState({
            page: state => state.dashboard.notifications.page,
            loading: state => state.dashboard.notifications.loading,
            notifications: state => state.dashboard.notifications.items,
            user: state => state.auth.user
        }),
        ...mapGetters({
            getAccommodationNotificationsFiltered: 'dashboard/getAccommodationNotificationsFiltered',
            accommodationNotificationsFilteredMaxPages: 'dashboard/accommodationNotificationsFilteredMaxPages',
            getAccommodationNotificationsFilteredPaginated: 'dashboard/getAccommodationNotificationsFilteredPaginated'
        })
    },
    methods: {
        ...mapActions({
            redirect: 'dashboard/redirect',
            dismissNotification: 'dashboard/dismissNotification',
            accommodationNotificationPageIncrement: 'dashboard/accommodationNotificationPageIncrement',
            accommodationNotificationPageDecrement: 'dashboard/accommodationNotificationPageDecrement',
        })
    }
});
</script>
<template>
    <div class="dashboard-notifications">
        <div class="dashboard-notifications__content">
            <div v-if="!loading" class="dashboard-notifications__container">
                <div class="dashboard-notifications__header">
                    <div class="dashboard-notifications__heading">
                        <span v-if="user.contractManager">
                            {{ $t('dashboard.notifications.list.header.contractHeading') }}
                        </span>
                        <span v-if="!user.contractManager">
                            {{ $t('dashboard.notifications.list.header.heading') }}
                        </span>
                        <span class="dashboard-notifications__notification-count">
                            {{ $tc('dashboard.notifications.list.header.count', getAccommodationNotificationsFiltered.length, {count: getAccommodationNotificationsFiltered.length}) }}
                        </span>
                    </div>
                    <div class="dashboard-notifications__filters">
                        <dashboard-notifications-filters/>
                    </div>
                </div>
                <table class="table dashboard-notifications__table">
                    <thead class="dashboard-notifications__table-head">
                        <tr>
                            <th>{{ $t('dashboard.notifications.list.accommodation') }}</th>
                            <th>{{ $t('dashboard.notifications.list.site') }}</th>
                            <th>{{ $t('dashboard.notifications.list.status.label') }}</th>
                            <th>{{ $t('dashboard.notifications.list.date') }}</th>
                            <th/>
                            <!--TODO: Include when the dismiss functionality has been reworked -->
                            <!--<th/>-->
                        </tr>
                    </thead>
                    <tbody v-if="notifications">
                        <tr v-for="(accommodation, index) in getAccommodationNotificationsFilteredPaginated" :key="index">
                            <td>{{ accommodation.accommodation }}</td>
                            <td>{{ accommodation.site }}</td>
                            <td class="dashboard-notifications__status">
                                {{ $t('dashboard.notifications.list.status.' + accommodation.status) }}
                            </td>
                            <td>
                                <span>{{ accommodation.from | moment("DD/MM/YYYY") }} - </span>
                                <span>{{ accommodation.to | moment("DD/MM/YYYY") }}</span>
                            </td>
                            <td>
                                <div :class="user.contractManager ? 'dashboard-notifications__link-contract' : 'dashboard-notifications__link'"
                                     @click="redirect({
                                         siteId: accommodation.siteId,
                                         accommodationSiteId: accommodation.accommodationSiteId,
                                         from: accommodation.from,
                                         to: accommodation.to})">
                                    <span v-if="!user.contractManager">
                                        {{ $t('dashboard.notifications.list.link') }}
                                    </span>
                                    <span v-if="user.contractManager">
                                        {{ $t('dashboard.notifications.list.contractLink') }}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!notifications || getAccommodationNotificationsFiltered.length === 0"
                     class="dashboard-notifications__no-content">
                    <i class="fa fa-bullhorn"/>
                    <div class="manage-allocation-list__error-message">
                        {{ $t('dashboard.notifications.noContent') }}
                    </div>
                </div>
                <div class="dashboard-notifications__items">
                    <div class="dashboard-notifications__items-list">
                        <dashboard-notifications-item v-for="(accommodation, index) in getAccommodationNotificationsFiltered"
                                                      :key="index"
                                                      :accommodation-site-id="accommodation.accommodationSiteId"
                                                      :accommodation="accommodation.accommodation"
                                                      :site-id="accommodation.siteId"
                                                      :site="accommodation.site"
                                                      :status="accommodation.status"
                                                      :from="accommodation.from"
                                                      :to="accommodation.to"
                                                      @add="redirect($event)"/>
                    </div>
                </div>
                <div v-if="notifications && getAccommodationNotificationsFiltered.length > 0"
                     class="dashboard-notifications__footer">
                    <div class="dashboard-notifications__pagination">
                        <pagination-control :max-pages="accommodationNotificationsFilteredMaxPages"
                                            :current-page="page"
                                            @prev="accommodationNotificationPageDecrement"
                                            @next="accommodationNotificationPageIncrement"/>
                    </div>
                </div>
            </div>
            <fake v-if="loading"
                  :header-rows="1"
                  :body-rows="12"
                  :body-cells="4"
                  :key="'fake'"/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/DashboardNotifications/DashboardNotifications.vue